module.exports = __webpack_public_path__ + "static/logo-90da41b5960ab558fd0d0d97dbc93759.svg";